import React, { useEffect } from 'react';
import Header from '../../headerone/Main';
import Bredcom from '../../Bredcom/Main';

function PrivacyPolicy() {
  useEffect(() => {
    document.getElementById("title").innerHTML = "Privacy Policy || State of GTS";
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />

      <div className="page-wrapper">
        <Bredcom
          subtitle="Home"
          title="Privacy Policy"
          subtitledown="Privacy Policy"
        />

        <section className="about-one-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="about-one-inner">
                  <p style={{ marginBottom: '20px', fontSize: '16px', color: '#666' }}>
                    Last updated: October 31, 2025
                  </p>

                  <h2 className="section-title" style={{ marginBottom: '30px' }}>
                    Introduction
                  </h2>
                  <p style={{ marginBottom: '30px', fontSize: '18px', lineHeight: '30px' }}>
                    Global Technology Solutions ("we", "our", "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website, use our mobile application, and engage with our services. Please read this privacy policy carefully. If you do not agree with the terms of this privacy policy, please do not access our services.
                  </p>

                  <h2 className="section-title" style={{ marginBottom: '30px', marginTop: '50px' }}>
                    Information We Collect
                  </h2>
                  <p style={{ marginBottom: '20px', fontSize: '18px', lineHeight: '30px' }}>
                    We may collect information about you in a variety of ways. The information we may collect includes:
                  </p>
                  <ul style={{ marginBottom: '30px', paddingLeft: '20px', fontSize: '18px', lineHeight: '30px' }}>
                    <li style={{ marginBottom: '15px' }}>
                      <strong>Personal Data:</strong> Personally identifiable information, such as your name, Social Security number, address, email address, and telephone number, that you voluntarily give to us when you apply for membership or services.
                    </li>
                    <li style={{ marginBottom: '15px' }}>
                      <strong>Financial Data:</strong> Financial information, such as data related to your account balances, transaction history, and credit history, when you use our financial services.
                    </li>
                    <li style={{ marginBottom: '15px' }}>
                      <strong>Derivative Data:</strong> Information our servers automatically collect when you access the Site, such as your IP address, your browser type, your operating system, your access times, and the pages you have viewed directly before and after accessing the Site.
                    </li>
                  </ul>

                  <h2 className="section-title" style={{ marginBottom: '30px', marginTop: '50px' }}>
                    Use of Your Information
                  </h2>
                  <p style={{ marginBottom: '20px', fontSize: '18px', lineHeight: '30px' }}>
                    Having accurate information about you permits us to provide you with a smooth, efficient, and customized experience. Specifically, we may use information collected about you to:
                  </p>
                  <ul style={{ marginBottom: '30px', paddingLeft: '20px', fontSize: '18px', lineHeight: '30px' }}>
                    <li style={{ marginBottom: '15px' }}>Create and manage your account.</li>
                    <li style={{ marginBottom: '15px' }}>Process transactions and send you related information.</li>
                    <li style={{ marginBottom: '15px' }}>Provide, maintain, and improve our services.</li>
                    <li style={{ marginBottom: '15px' }}>Prevent fraudulent transactions and monitor against theft.</li>
                    <li style={{ marginBottom: '15px' }}>Comply with legal and regulatory obligations.</li>
                  </ul>

                  <h2 className="section-title" style={{ marginBottom: '30px', marginTop: '50px' }}>
                    Sharing of Your Information
                  </h2>
                  <p style={{ marginBottom: '30px', fontSize: '18px', lineHeight: '30px' }}>
                    We do not share your nonpublic personal information with non-affiliated third parties, except as permitted or required by law. We may share information with our trusted partners to offer you products and services that may be of interest to you, but you will have the option to opt-out of such sharing.
                  </p>

                  <h2 className="section-title" style={{ marginBottom: '30px', marginTop: '50px' }}>
                    Security of Your Information
                  </h2>
                  <p style={{ marginBottom: '30px', fontSize: '18px', lineHeight: '30px' }}>
                    We use administrative, technical, and physical security measures to help protect your personal information. While we have taken reasonable steps to secure the personal information you provide to us, please be aware that despite our efforts, no security measures are perfect or impenetrable, and no method of data transmission can be guaranteed against any interception or other type of misuse.
                  </p>

                  <h2 className="section-title" style={{ marginBottom: '30px', marginTop: '50px' }}>
                    SMS Privacy Policy
                  </h2>
                  <p style={{ marginBottom: '30px', fontSize: '18px', lineHeight: '30px' }}>
                    No mobile information will be shared with third parties/affiliates for marketing/promotional purposes. All the above categories exclude text messaging originator opt-in data and consent; this information will not be shared with any third parties.
                  </p>

                  <h2 className="section-title" style={{ marginBottom: '30px', marginTop: '50px' }}>
                    Contact Us
                  </h2>
                  <p style={{ marginBottom: '50px', fontSize: '18px', lineHeight: '30px' }}>
                    If you have questions or comments about this Privacy Policy, please contact us through the <a href="/contact" style={{ color: 'var(--thm-primary)' }}>Contact</a> section of our website.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default PrivacyPolicy;

